import React, { useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
import Axios from '../config';
import Loader from './Loader';
import { getErrorMessage, validateEmail } from '../utils';

const Footer = () => {
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 768px)' });

    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false); // Initialize as false
    const [emailError, setEmailError] = useState('');
    const emailInputRef = useRef(null);

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        setEmailError(''); // Clear error on change
    };

    const handleSubscribe = async (e) => {
        e.preventDefault();
        setLoading(true);
        setEmailError(''); // Clear previous errors

        try {
            if (email.trim() === '') {
                setEmailError('Please enter your email address.');
                emailInputRef.current.focus();
                setLoading(false);
                return;
            }

            if (!validateEmail(email.trim())) {
                setEmailError('Please enter a valid email address.');
                emailInputRef.current.focus();
                setLoading(false);
                return;
            }

            const { data } = await Axios.post('/newsletter/subscribe', { email });

            if (data) {
                swal('Success', 'Newsletter Subscription Successful!', 'success').then(() => {
                    setEmail(''); // Clear email input
                });
            }
            setLoading(false);
        } catch (error) {
            swal('Oops', getErrorMessage(error), 'error');
            setLoading(false);
        }
    };

    return (
        <footer id="footer" className="footer light-background">
            <div className="container">
                <div className="row gy-4 footer-top-section"> {/* Added footer-top-section class */}
                    <div className="col-lg-3 col-md-6 d-flex footer-info-block"> {/* Added footer-info-block */}
                        <i className="bi bi-geo-alt icon"></i>
                        <div className="address">
                            <h4>Our Location</h4>
                            <p>Suite C6 OG Winner's Plaza, Bank Road, Beside UBA, Makurdi, Benue State.</p>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6 d-flex footer-info-block"> {/* Added footer-info-block */}
                        <i className="bi bi-telephone icon"></i>
                        <div>
                            <h4>Contact Us</h4>
                            <p>
                                <strong>Phone:</strong> <span>08057795292, 08050403030, 09063809922, 08178440932, +2349024351595</span><br />
                                <strong>Email:</strong> <span>info@panduspowells.com</span><br />
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6 d-flex footer-info-block"> {/* Added footer-info-block */}
                        <i className="bi bi-clock icon"></i>
                        <div>
                            <h4>Operating Hours</h4>
                            <p>
                                <strong>Mon-Fri:</strong> <span>9:00 AM - 4:00 PM</span><br />
                                <strong>Saturday:</strong> <span>10:00 AM - 2:00 PM</span><br />
                                <strong>Sunday</strong>: <span>Closed</span>
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <h4>Follow Us</h4>
                        <p>Connect with us on social media for updates and news regarding NIN enrollment.</p>
                        <div className="social-links d-flex">
                            <a href="https://x.com/panduspowells" target="_blank" rel="noopener noreferrer" className="twitter"><i className="bi bi-twitter-x"></i></a>
                            <a href="https://facebook.com/panduspowells" target="_blank" rel="noopener noreferrer" className="facebook"><i className="bi bi-facebook"></i></a>
                            <a href="https://instagram.com/panduspowells" target="_blank" rel="noopener noreferrer" className="instagram"><i className="bi bi-instagram"></i></a>
                            <a href="https://linkedin.com/company/panduspowells" target="_blank" rel="noopener noreferrer" className="linkedin"><i className="bi bi-linkedin"></i></a>
                        </div>
                    </div>
                </div>

                {/* Newsletter Subscription Section */}
                <div className="row mt-5">
                    <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 newsletter-section"> {/* Added newsletter-section class */}
                        <form className="newsletter-form">
                            <h5 className="text-center">Subscribe to Our NIN Enrollment Newsletter</h5>
                            <p className="text-center text-muted">
                                Get the latest updates, important announcements, and tips related to NIN enrollment directly in your inbox.
                            </p>
                            <div className="d-flex flex-column flex-sm-row w-100 gap-2 mt-3">
                                <label htmlFor="newsletter" className="visually-hidden">
                                    Email address
                                </label>
                                <div className="input-group has-validation">
                                    <span className="input-group-text">
                                        <i className="bi bi-envelope-at"></i>
                                    </span>
                                    <input
                                        id="newsletter"
                                        type="email"
                                        className={`form-control ${emailError ? 'is-invalid' : ''} ${email && !emailError ? 'is-valid' : ''}`}
                                        placeholder="Your email address"
                                        required
                                        value={email}
                                        onChange={handleEmailChange}
                                        ref={emailInputRef}
                                    />
                                    <div className="invalid-feedback">{emailError}</div>
                                </div>
                                {loading && <Loader />}
                                <button
                                    className="btn btn-primary shadow" // Changed to btn-primary, adjust as needed for your theme
                                    onClick={handleSubscribe}
                                    disabled={loading}
                                >
                                    {loading ? 'Subscribing...' : 'Subscribe'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="container copyright text-center mt-4 pt-3 border-top">
                    <p>{new Date().getFullYear()} © <span>Copyright</span> <strong className="px-1 sitename">PandusPowells.</strong> <span>All Rights Reserved</span></p>
                    <div className="credits">
                        Developed by <a href="https://omimek.com" target="_blank" rel="noopener noreferrer">Omimek Technology</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;